// extracted by mini-css-extract-plugin
export var bubble = "_2x-0";
export var container = "_2x-f";
export var contrastBorder = "_2x-g";
export var greyOut = "_2x-2";
export var initialsColor0 = "_2x-3";
export var initialsColor1 = "_2x-4";
export var initialsColor10 = "_2x-d";
export var initialsColor11 = "_2x-e";
export var initialsColor2 = "_2x-5";
export var initialsColor3 = "_2x-6";
export var initialsColor4 = "_2x-7";
export var initialsColor5 = "_2x-8";
export var initialsColor6 = "_2x-9";
export var initialsColor7 = "_2x-a";
export var initialsColor8 = "_2x-b";
export var initialsColor9 = "_2x-c";
export var initialsWrapper = "_2x-1";
export var large = "_2x-l";
export var medium = "_2x-k";
export var mediumSmall = "_2x-j";
export var mediumSmallMedium = "_2x-o";
export var micro = "_2x-h";
export var small = "_2x-i";
export var tiny = "_2x-n";
export var xTiny = "_2x-m";